"use strict";
export default (document) => {
  const validTypes = [
    "contract",
    "noticeOfRelease",
    "noticeOfAssignment",
    "insuranceCertificate",
    "w9",
    "assignment",
    "voidedCheck",
    "achSetupForm"
  ];
  return document && validTypes.indexOf(document.type) >= 0;
};
